export const COMPANIES_MANAGEMENT_ACTION = {
  GET_COMPANIES: 'GET_COMPANIES',
  GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
  GET_COMPANIES_ERROR: 'GET_COMPANIES_ERROR',
};
// =========================================================================
export const getCompanies = () => ({
  type: COMPANIES_MANAGEMENT_ACTION.GET_COMPANIES,
});
